<template>
    <v-dialog
    v-model="dialog"
    @click:outside="closeDialog"
    max-width="700px"
    scrollable
    z-index="210"
  >
        <v-card >
            <v-toolbar dense :elevation="0">
                <v-toolbar-title class="text-primary-700">Links</v-toolbar-title>
                <div class="flex-grow-1"></div>
                <v-btn style="width: 35px; height: 35px" icon @click="closeDialog">
                <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pt-4">
                <!-- add link button -->
                <v-text-field
                    v-model="linkInput"
                    label="Add Link"
                    placeholder="Add links to external documents or websites"
                    outlined
                    dense
                    hide-details
                    append-icon="mdi-plus"
                    class="mb-2"
                    @click:append="addLink"
                ></v-text-field>
                <v-simple-table dense style="width:100%; border: 1px solid #e0e0e0; border-radius: 4px;" >
                    <template v-slot:default>
                        <tbody class="rpd-d-tbody" v-if="item.links.data.length > 0">
                            <tr v-for="(item, index) in item.links.data" :key="index">
                                <td style="text-wrap: break-word; word-break: break-all;" >
                                    <a :href="item.link_url" target="_blank">{{ item.link_url }}</a>
                                </td>
                                <td style="width:0%; min-width: 50px;"  class="text-right">
                                    <v-btn icon small @click="deleteDeal(item)">
                                        <v-icon small>mdi-delete</v-icon>
                                    </v-btn>
                                </td>
                            </tr>
                        </tbody>
                        <tbody class="rpd-d-tbody"  v-else>
                            <tr>
                                <td class="text-center grey--text text--darken-1">
                                    This deal has no links yet.
                                </td>
                            </tr>
                            </tbody>
                    </template>
                </v-simple-table>
                
            </v-card-text>
            <edit-property-dialog ref="editPropertyDialog"></edit-property-dialog>
            <edit-scheme-dialog ref="editSchemeDialog"></edit-scheme-dialog>
            <edit-company-dialog ref="editCompanyDialog"></edit-company-dialog>
            <edit-user-dialog ref="editUserDialog"></edit-user-dialog>
        </v-card>        
    </v-dialog>
</template>
<script>
    import EditSchemeDialog from '@/components/schemes/editSchemeDialog'
    import EditPropertyDialog from '@/components/properties/editPropertyDialog'
    import EditCompanyDialog from "@/components/companies/editCompanyDialog.vue";
    import EditUserDialog from "@/components/users/editUserDialog.vue";
    
    export default {
        components: {
            EditSchemeDialog,
            EditPropertyDialog,
            EditCompanyDialog,
            EditUserDialog
        },

        data: () => ({
            dialog: false,
            linkInput: '',
            item: {},
        }),
        // props: ['dealID'],
        methods: {
            showDialog: function (item) {
                this.item = item;
                this.dialog = true;
            },
            
            closeDialog: function () {
                this.dialog = false;
            },

            deleteDeal: function (item) {
                this.$notify.question(`Are you sure you want to delete this link? <b>${item.link_url}</b>`, () => {
                    this.$http.delete(`deal-links/${item.id}`).then(response => {
                        // remove the item from the list
                        this.item.links.data = this.item.links.data.filter(link => link.id !== item.id);
                        this.$emit('deleted', item);
                    }).catch(error => {
                        this.$notify.error('An error occurred. Please try again later');
                    })
            });
            },

            addLink(){


                // verify link regex
                let expression = '(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})'
                let regex = new RegExp(expression)
                if(!regex.test(this.linkInput)){
                    this.$notify.error('Invalid URL')
                    return
                }

                this.$http.post(`deals/${this.item.id}/links`, {
                    link_url: this.linkInput
                }).then(response => {
                    // add the item to the list
                    this.item.links.data.push(response.data.data.link);
                    this.linkInput = '';
                }).catch(error => {
                    this.$notify.error('An error occurred. Please try again later');
                })

            },
            
        },
    }

</script>
<style>
    .deal-td{
        width: 200px;
    }
</style>